"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumMember = void 0;
// Tests if a string is a member of the passed enum. Type-safe.
const isEnumMember = (anEnum, member) => {
    return Object.values(anEnum).includes(member);
};
exports.isEnumMember = isEnumMember;
//# sourceMappingURL=isEnumMember.js.map